import { ReactNode, VFC } from 'react'
import { Logo } from 'src/assets/svgs'
import { Link } from 'src/elements/Link'
import { truewhite } from 'src/styles/colors'
import { MYPAGE, TOP } from 'src/utils/routes'
import styled from 'styled-components'

export const HeaderWrapper: VFC<{ children: ReactNode; member?: boolean }> = ({
  children,
  member,
}) => {
  return (
    <>
      <Header>
        <Link href={member ? MYPAGE : TOP}>
          <Logo height="40px" />
        </Link>
        <Navigation>{children}</Navigation>
      </Header>
    </>
  )
}

export const HEADER_HEIGHT = '70px'

const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: ${HEADER_HEIGHT};
  padding: 10px 60px 0 0px;

  background-color: ${truewhite};
  box-shadow: 0px 0px 5px #00000050;
`

const Navigation = styled.nav`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
`
